_ = require 'underscore'
Hearsay = require 'hearsay'
PluginIOCache = require 'app/scripts/views/internal/plugins/plugin-io-cache'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
PluginView = require 'app/scripts/views/plugin/plugin-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
sandboxParams = require 'app/scripts/data/plugin-iframe-sandbox'
{ sendPluginScreenEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'
t = require('app/scripts/views/internal/teacup-with-helpers')('plugin_section')
{ IconDefaultColor } = require '@trello/nachos'
xtend = require 'xtend'

template = t.renderable (data) ->
  { content, iframeType, popoverIsVisible } = data
  t.div '.window-module.u-clearfix', ->

    t.div '.window-module-title.window-module-title-no-divider', ->
      t.span '.window-module-title-icon.icon-lg.plugin-section-icon.js-icon'
      t.h3 '.u-inline-block.plugin-section-title.js-title'
      return

    if content.type == 'iframe' && pluginValidators.isValidUrlForIframe(content.url)
      { url, height } = content
      if !pluginValidators.isValidHeight(height, 400)
        height = 400
      t.div class: t.classify({
        'u-gutter': true,
        'js-plugin-iframe-container': true,
        'plugin-iframe-container-pop-over-shown': popoverIsVisible
      }), ->
        t.iframe '.plugin-iframe.plugin-section.plugin-card-back-section',
          allow: 'microphone; camera'
          sandbox: sandboxParams
          src: url
          style: t.stylify
            height: if height then "#{ height }px;" else undefined
        t.div '.plugin-iframe-popover-overlay'
        return
    return
  return

module.exports = class PluginCardBackSectionView extends PluginView

  initialize: ->
    @section = new Hearsay.Slot(null)

  renderOnce: ->
    section = @section.get()
    if !section?
      throw Error('updateSection not called before render')

    @$el.html(template(xtend(section, popoverIsVisible: PopOver.isVisible)))

    @subscribe @section, (latestSection) =>
      Promise.resolve(_.result(latestSection, 'title'))
      .then (title) =>
        @$('.js-title').text(title)
      .catch PluginRunner.Error.Timeout, (->)

      Promise.resolve(_.result(latestSection, 'icon'))
      .then (icon) =>
        iconUrl = t.addRecolorParam(icon, "?color=#{ IconDefaultColor.substr(1).toLowerCase() }")
        @$('.js-icon')
          .css('background-image', t.urlify(iconUrl))
          .toggleClass('mod-reset', latestSection.monochrome == false)
      .catch PluginRunner.Error.Timeout, (->)
    @initIFrames(@model.getBoard(), @model, @section)

    sendPluginScreenEvent({
      idPlugin: section.idPlugin
      idBoard: @model.getBoard().id
      idCard: @model.id
      screenName: 'pupCardBackSectionInlineDialog'
    })

    @

  updateSection: (section) ->
    @section.set(section)
